import { Navigate, Outlet } from 'react-router-dom';
import { can, type Me } from './me';
import { useMe } from './useMe';

/** Route guard: owner-only, or a required resource/action. The server enforces the same rule; this avoids dead-end screens. */
export function RequireAccess(props: { owner: true } | { resource: string; action: string } | { check: (me: Me) => boolean }) {
  const { me } = useMe();
  const allowed = me && ('owner' in props ? me.isOwner : 'check' in props ? props.check(me) : can(me, props.resource, props.action));
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
